
import Vue, { PropType } from 'vue'
import { AlertDestination } from '@/models'

import AlertDestinationListHeader from './AlertDestinationListHeader.vue'
import AlertDestinationListItem from './AlertDestinationListItem.vue'

export default Vue.extend({
  name: 'AlertDestinationList',

  props: {
    alertDestinations: Array as PropType<Array<AlertDestination>>,
  },

  components: {
    AlertDestinationListHeader,
    AlertDestinationListItem
  },
})
